import { atom } from "@reatom/framework";

import { ProductFilters } from "../../widgets/ProductFilters/ProductFilters";

export const filterAtom = atom<ProductFilters>({}, "filterAtom");
